<template>
    <div class="main-container">
        <navbar :back_path="'/ticket-activity-detail/?apply_id=' + apply_id" :hide_search="true" active_screen="แนบเอกสาร" />
        <div :class="'ml-20 mr-20 mb-20 mt-20 container-password is-' + $device" style="padding-bottom: 16px">
            <a-spin :tip="$t('Loading...')" :spinning="getting_data">
                <div class="row">
                    <div class="col-12 text-center">
                        <span class="fs-20 black fw-600" style="display: block">{{ticket_data.title}}</span>
                    </div>
                </div>
                <!-- <div class="row mt-16">
                    <div class="col-6">
                        <span class="fs-18 black" style="display: block">เอกสาร</span>
                    </div>
                    <div class="col-6">
                        <span class="fs-18 black" style="display: block">สถานะ</span>
                    </div>
                </div> -->
                <div v-for="(tl, k) in ticket_data.ticket_data.ticket_list" :key="k" style="background-color: #fff; border-radius: 25px; padding: 16px; margin-top: 16px; margin-bottom: 16px">
                    <div class="row text-left">
                        <div class="col-12">
                            <span class="fs-18 black" style="display: block">ตั๋วใบที่ {{ k + 1 }}</span>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 20px" v-for="(doc, k1) in tl.doc" :key="k1">
                        <div class="col-8">
                            <span class="fs-18 black tal" style="display: block">{{ doc.label }}</span>
                        </div>
                        <div class="col-2">
                            <img :src="doc.status_upload ? 'resources/images/check.png' : 'resources/images/check-gray.png'" style="width: 60%; min-width: 25px" />
                        </div>
                        <div class="col-1" style="text-align: left; margin-top: 0px">
                            <a-icon type="upload" :style="{ color: '#000000', fontSize: '24px' }" @click="handleStep(tl.ticket_id, doc)" />
                        </div>
                    </div>
                </div>
                <modal-form :visible="modal_visible" :step="modal_step" @handle-step="onModalChangeStep" @on-cancel="onModalCancel" :init_doc="doc" />
            </a-spin>
        </div>
    </div>
</template>
<script>
import navbar from '../../components/navbar';
import moment from 'moment';
import modalForm from './modalForm';
import store from 'store';
import _ from 'lodash';
export default {
    components: {
        modalForm,
        navbar,
    },
    data: function () {
        return {
            getting_data: true,
            modal_visible: false,
            modal_step: null,
            ticket_data: {
                apply_id: 50236,
                act_id: 659,
                image_full: 'https://apigwd.scg.com/DebentureClubDev/images/activity/2I6K61649051975.jpg',
                image: 'https://apigwd.scg.com/DebentureClubDev/images/activity_resize/2I6K61649051975.jpg',
                title: 'SCG Smiling : แผ่นภาพ คิด Learn',
                act_day: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30-11.30 น.',
                confirm_phone_date: null,
                confirm_mail_date: 1654016400,
                confirm_sms_date: 1654016400,
                code: 'SCG087620',
                date: 1649992609,
                group_receive: {
                    group_id: 768,
                    title: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30 - 11.30 น.',
                    display_order: 1,
                    start_date: 1653098400,
                    end_date: 1653107400,
                },
                group_choose1: {
                    group_id: 768,
                    title: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30 - 11.30 น.',
                    display_order: 1,
                    start_date: 1653098400,
                    end_date: 1653107400,
                },
                group_choose2: null,
                group_choose3: null,
                atype_name: 'เวิร์คชอป',
                confirm_flag: 0,
                status: 'รอเข้าร่วม',
                button_cancel: true,
                button_confirm: false,
                button_form: false,
                attach_file_pid: true,
                attach_file_passport: false,
                attach_file_payment: true,
                accom_form: true,
                member_form: true,
                accom: [],
                ticket_data: {
                    main_pdf: 'https://apigwd.scg.com/DebentureClubDev/files/activity/KL3Vj1651225662.pdf',
                    label_doc_btn: 'เอกสาร',
                    display_doc_btn: true,
                    label_ticket_btn: 'ตั๋วอิเล็กทรอนิกส์',
                    display_ticket_btn: true,
                    label_attach_btn: 'แนบเอกสาร',
                    display_attach_btn: true,
                    doc_list: [
                        {
                            label: 'กำหนดการกิจกรรม.pdf',
                            pdf_url: 'https://apigwd.scg.com/DebentureClubDev/files/activity/doc/dGs6o1652196187.pdf',
                        },
                        {
                            label: 'แบบฟอร์มผลตรวจ ATK.pdf',
                            pdf_url: 'https://apigwd.scg.com/DebentureClubDev/files/activity/doc/ZAOYD1652196187.pdf',
                        },
                        {
                            label: 'แผนที่เอสซีจี.pdf',
                            pdf_url: 'https://apigwd.scg.com/DebentureClubDev/files/activity/doc/yUQ3R1652196187.pdf',
                        },
                    ],
                    ticket_list: [
                        {
                            ticket_id: 16,
                            no: 'ตั๋วใบที่ 1',
                            ticket_no: 'WS221A1A2A3A4A5',
                            group_name: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30 - 11.30 น.',
                            start_at: 1653098400,
                            end_at: 1653107400,
                            ticket_template: '2',
                            ticket_bg: '#ffebcd',
                            ticket_font_color: '#006633',
                            ticket_header_bg: '#cc3333',
                            ticket_header_font_color: '#ffffff',
                            ticket_body_bg: null,
                            ticket_body_font_color: '#191970',
                            active: false,
                            active_txt: 'ใช้งานแล้ว',
                            qrcode: 'https://apigwd.scg.com/DebentureClubDev/images/activity/disable-qrcode.jpg',
                            pin: '7400',
                            share: 'https://debentureclub-dev.scg.com/share/ticket/c74d97b01eae257e44aa9d5bade97baf',
                            location_line1: 'สถานที่',
                            location_line2: 'ห้องแกรนด์ฮอลล์ ชั้น 10  อาคารอเนกประสงค์  เอสซีจี บางซื่อ',
                            label1: 'ลงทะเบียน',
                            value1: 'A1',
                            label2: 'แถวที่นั่ง',
                            value2: 'A2',
                            label3: 'เลขที่นั่ง',
                            value3: 'A3',
                            label4: 'label4',
                            value4: 'A4',
                            label5: 'label5',
                            value5: 'A5',
                            doc: [
                                {
                                    attach_label_id: 6,
                                    label: 'ผลตรวจ ATK',
                                    display_upload_btn: true,
                                    status_upload: false,
                                    file: null,
                                },
                                {
                                    attach_label_id: 11,
                                    label: 'ประวัติการรับวัคซีนโควิด-19',
                                    display_upload_btn: true,
                                    status_upload: true,
                                    file: 'https://apigwd.scg.com/DebentureClubDev/files/activity/ticket/doc/uWgZX1652171907.jpg',
                                },
                            ],
                            condition: '<p>ทดสอบเงื่อนไขกลุ่ม 1</p>',
                        },
                        {
                            ticket_id: 17,
                            no: 'ตั๋วใบที่ 2',
                            ticket_no: 'WS221A0A2A3A4A5',
                            group_name: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30 - 11.30 น.',
                            start_at: 1653098400,
                            end_at: 1653107400,
                            ticket_template: '2',
                            ticket_bg: '#ffebcd',
                            ticket_font_color: '#006633',
                            ticket_header_bg: '#cc3333',
                            ticket_header_font_color: '#ffffff',
                            ticket_body_bg: null,
                            ticket_body_font_color: '#191970',
                            active: true,
                            active_txt: 'ยังไม่ได้ใช้งาน',
                            qrcode: 'https://apigwd.scg.com/DebentureClubDev/images/ticket-qrcode/70efdf2ec9b086079795c442636b55fb.png',
                            pin: '7400',
                            share: 'https://debentureclub-dev.scg.com/share/ticket/70efdf2ec9b086079795c442636b55fb',
                            location_line1: 'สถานที่',
                            location_line2: 'ห้องแกรนด์ฮอลล์ ชั้น 10  อาคารอเนกประสงค์  เอสซีจี บางซื่อ',
                            label1: 'ลงทะเบียน',
                            value1: 'A0',
                            label2: 'แถวที่นั่ง',
                            value2: 'A2',
                            label3: 'เลขที่นั่ง',
                            value3: 'A3',
                            label4: 'label4',
                            value4: 'A4',
                            label5: 'label5',
                            value5: 'A5',
                            doc: [
                                {
                                    attach_label_id: 6,
                                    label: 'ผลตรวจ ATK',
                                    display_upload_btn: true,
                                    status_upload: true,
                                    file: 'https://apigwd.scg.com/DebentureClubDev/files/activity/ticket/doc/t4cZR1652106106.jpg',
                                },
                                {
                                    attach_label_id: 11,
                                    label: 'ประวัติการรับวัคซีนโควิด-19',
                                    display_upload_btn: true,
                                    status_upload: false,
                                    file: null,
                                },
                            ],
                            condition: '<p>ทดสอบเงื่อนไขกลุ่ม 1</p>',
                        },
                        {
                            ticket_id: 18,
                            no: 'ตั๋วใบที่ 3',
                            ticket_no: 'WS221A2A2A3A4A5',
                            group_name: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30 - 11.30 น.',
                            start_at: 1653098400,
                            end_at: 1653107400,
                            ticket_template: '2',
                            ticket_bg: '#ffebcd',
                            ticket_font_color: '#006633',
                            ticket_header_bg: '#cc3333',
                            ticket_header_font_color: '#ffffff',
                            ticket_body_bg: null,
                            ticket_body_font_color: '#191970',
                            active: true,
                            active_txt: 'ยังไม่ได้ใช้งาน',
                            qrcode: 'https://apigwd.scg.com/DebentureClubDev/images/ticket-qrcode/6f4922f45568161a8cdf4ad2299f6d23.png',
                            pin: '7400',
                            share: 'https://debentureclub-dev.scg.com/share/ticket/6f4922f45568161a8cdf4ad2299f6d23',
                            location_line1: 'สถานที่',
                            location_line2: 'ห้องแกรนด์ฮอลล์ ชั้น 10  อาคารอเนกประสงค์  เอสซีจี บางซื่อ',
                            label1: 'ลงทะเบียน',
                            value1: 'A2',
                            label2: 'แถวที่นั่ง',
                            value2: 'A2',
                            label3: 'เลขที่นั่ง',
                            value3: 'A3',
                            label4: 'label4',
                            value4: 'A4',
                            label5: 'label5',
                            value5: 'A5',
                            doc: [
                                {
                                    attach_label_id: 6,
                                    label: 'ผลตรวจ ATK',
                                    display_upload_btn: true,
                                    status_upload: false,
                                    file: null,
                                },
                                {
                                    attach_label_id: 11,
                                    label: 'ประวัติการรับวัคซีนโควิด-19',
                                    display_upload_btn: true,
                                    status_upload: false,
                                    file: null,
                                },
                            ],
                            condition: '<p>ทดสอบเงื่อนไขกลุ่ม 1</p>',
                        },
                        {
                            ticket_id: 40,
                            no: 'ตั๋วใบที่ 4',
                            ticket_no: 'WS2211001',
                            group_name: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30 - 11.30 น.',
                            start_at: 1653098400,
                            end_at: 1653107400,
                            ticket_template: '2',
                            ticket_bg: '#ffebcd',
                            ticket_font_color: '#006633',
                            ticket_header_bg: '#cc3333',
                            ticket_header_font_color: '#ffffff',
                            ticket_body_bg: null,
                            ticket_body_font_color: '#191970',
                            active: true,
                            active_txt: 'ยังไม่ได้ใช้งาน',
                            qrcode: 'https://apigwd.scg.com/DebentureClubDev/images/ticket-qrcode/d645920e395fedad7bbbed0eca3fe2e0.png',
                            pin: '7400',
                            share: 'https://debentureclub-dev.scg.com/share/ticket/d645920e395fedad7bbbed0eca3fe2e0',
                            location_line1: 'สถานที่',
                            location_line2: 'ห้องแกรนด์ฮอลล์ ชั้น 10  อาคารอเนกประสงค์  เอสซีจี บางซื่อ',
                            label1: 'ลงทะเบียน',
                            value1: '08.00 – 09.00 น.',
                            label2: 'แถวที่นั่ง',
                            value2: '1',
                            label3: 'เลขที่นั่ง',
                            value3: '001',
                            label4: '',
                            value4: '',
                            label5: '',
                            value5: '',
                            doc: [
                                {
                                    attach_label_id: 6,
                                    label: 'ผลตรวจ ATK',
                                    display_upload_btn: true,
                                    status_upload: true,
                                    file: 'https://apigwd.scg.com/DebentureClubDev/files/activity/ticket/doc/Hei141652166645.jpg',
                                },
                                {
                                    attach_label_id: 11,
                                    label: 'ประวัติการรับวัคซีนโควิด-19',
                                    display_upload_btn: true,
                                    status_upload: true,
                                    file: 'https://apigwd.scg.com/DebentureClubDev/files/activity/ticket/doc/wiUfs1652170652.jpg',
                                },
                            ],
                            condition: '<p>ทดสอบเงื่อนไขกลุ่ม 1</p>',
                        },
                    ],
                },
            },
            loading: false,
            password: store.get('password_ticket'),
            key: store.get('key_ticket'),
            doc: null,
            apply_id: this.$route.query.apply_id,
        };
    },
    mounted() {
        this._mounted();
    },
    methods: {
        _mounted: function () {
            this.getTicket(() => (this.getting_data = false));
        },
        getTicket: function (callback = null) {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/log/activity/detail',
                    data: {
                        apply_id: this.apply_id,
                    },
                    callback: (res) => {
                        if (res && res.result == 'errors') {
                            const error = {
                                title: '',
                            };
                            for (const [key, value] of Object.entries(res.errors)) {
                                console.log('value', value);
                                if (key) {
                                    error.title = value[0];
                                }
                            }
                            this.$confirm({
                                title: error.title,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {},
                            });
                        } else {
                            this.ticket_data = res;
                            // this.modal_visible = true;
                            // this.modal_step = 'upload';
                        }
                        if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        onPinPress(pin) {
            if (pin == 'del') this.password = this.password.slice(0, -1);
            else if (this.password.length >= 6) return false;
            else this.password += String(pin);
        },
        async onShare(textToCopy) {
            try {
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(textToCopy);
                    this.$alert(null, 'คัดลอกสำเร็จ!', null, {
                        confirmButtonText: 'OK',
                        customClass: 'normal-alert-ok-btn',
                    });
                } else {
                    const textArea = document.createElement('textarea');
                    textArea.value = textToCopy;
                    textArea.style.position = 'fixed';
                    textArea.style.left = '-999999px';
                    textArea.style.top = '-999999px';
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    return new Promise((resolve) => {
                        if (document.execCommand('copy')) {
                            this.$alert(null, 'คัดลอกสำเร็จ!', null, {
                                confirmButtonText: 'OK',
                                customClass: 'normal-alert-ok-btn',
                            });
                            resolve();
                        }
                        textArea.remove();
                    });
                }
            } catch (e) {
                this.$alert(null, 'คัดลอกไม่สำเร็จ!', null, {
                    confirmButtonText: 'OK',
                    customClass: 'normal-alert-ok-btn',
                });
            }
        },
        handleStep(ticket_id, doc) {
            console.log('doc', doc);
            this.modal_step = doc.label;
            this.doc = doc;
            this.doc.ticket_id = ticket_id;
            this.modal_visible = true;
        },
        onModalChangeStep(doc) {
            this.modal_step = doc.label;
            this.doc = doc;
        },
        onModalCancel() {
            this.modal_visible = false;
            this.modal_step = null;
            this.getTicket(() => (this.getting_data = false));
        },
        toMoment(date_unix, format) {
            return this.mtby(moment.unix(date_unix), format);
        },
        size(v) {
            return _.size(v);
        },
        get(v1, v2, v3) {
            return _.get(v1, v2, v3);
        },
    },
};
</script>
<style scoped>
.navbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    /* height: 40px; */
    /* height: 10vh; */
    height: 48px;
    padding: 0 8px;
    z-index: 2;
}
.custom-close {
    font-weight: 300;
    margin: 0;
    color: #707070 !important;
    text-align: right;
    opacity: 0.5;
}
.center1 {
    /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
}
.center2 {
    text-align: center;
}
.pinRC {
    display: none;
}
.pinC {
    display: block;
    position: relative;
    width: 270px;
    height: 220px;
    margin: 0 auto;
}
.pinC > .pinB {
    position: relative;
    float: left;
    width: calc(270px / 3);
    height: calc(220px / 3);
    text-align: center;
    /* line-height: 3; */
    -webkit-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    -o-transition: all 0.2s ease;
    transition: all 0.2s ease;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.pinC > .pinB:not(.empty) {
    /* background-color: #dcdcdc; */
    background-color: transparent;
    border: 2px solid #ffffff;
}
.pinC > .pinB:not(.empty):hover {
    /*     border: 2px dotted #fefefe; */
    cursor: pointer;
}
.pinC > .pinB:not(.empty)::before {
    content: ' ';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(100, 100, 100, 0);
    /* background-color: transparent; */
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.pinC > .pinB:not(.empty):active::before {
    background-color: rgba(200, 200, 200, 0.45);
}
.pinC > .pinB > .pin_T {
    /* position: absolute;
  width: 100%;
  left: 0%;
  height: 100%; */
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    font-size: 26px;
    font-weight: 600;
}
.pin_T.pDelete {
    font-weight: 300 !important;
}
.pinC > .pinB > .pin_t {
    font-size: 75%;
    position: absolute;
    bottom: -5px;
    left: 50%;
    color: darkgrey;
    transform: translate(-50%, 0);
}
.pinC > .pinB.input > .pinpart {
    border: 2px solid #000000;
    border-radius: 50%;
    float: left;
    width: 10px;
    height: 10px;
    position: relative;
    top: calc(50% - 5px);
    margin-left: 4.5px;
    background-color: rgba(100, 100, 100, 0);
    /* background-color: transparent; */
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.pinC > .pinB.input > .pinpart.active {
    background-color: #000000;
}
.confirmed {
    animation: removec ease-out 1s;
    animation-iteration-count: 1;
    transform-origin: 0% 50%;
    animation-fill-mode: forwards;
    /*when the spec is finished*/
    -webkit-animation: removec ease-out 1s;
    -webkit-animation-iteration-count: 1;
    -webkit-transform-origin: 0% 50%;
    -webkit-animation-fill-mode: forwards;
    /*Chrome 16+, Safari 4+*/
    -moz-animation: removec ease-out 1s;
    -moz-animation-iteration-count: 1;
    -moz-transform-origin: 0% 50%;
    -moz-animation-fill-mode: forwards;
    /*FF 5+*/
    -o-animation: removec ease-out 1s;
    -o-animation-iteration-count: 1;
    -o-transform-origin: 0% 50%;
    -o-animation-fill-mode: forwards;
    /*Not implemented yet*/
    -ms-animation: removec ease-out 1s;
    -ms-animation-iteration-count: 1;
    -ms-transform-origin: 0% 50%;
    -ms-animation-fill-mode: forwards;
    /*IE 10+*/
}
.custom-modal-footer-single-close-btn {
    background: linear-gradient(0deg, #ff7105, #ff9500 100%) no-repeat;
    color: #fff;
    width: 100%;
}
@keyframes removec {
    0% {
        opacity: 1;
        transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        transform: translate(0px, 0px) scaleX(0);
    }
}
@-moz-keyframes removec {
    0% {
        opacity: 1;
        -moz-transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        -moz-transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        -moz-transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        -moz-transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        -moz-transform: translate(0px, 0px) scaleX(0);
    }
}
@-webkit-keyframes removec {
    0% {
        opacity: 1;
        -webkit-transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        -webkit-transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        -webkit-transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        -webkit-transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        -webkit-transform: translate(0px, 0px) scaleX(0);
    }
}
@-o-keyframes removec {
    0% {
        opacity: 1;
        -o-transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        -o-transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        -o-transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        -o-transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        -o-transform: translate(0px, 0px) scaleX(0);
    }
}
@-ms-keyframes removec {
    0% {
        opacity: 1;
        -ms-transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        -ms-transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        -ms-transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        -ms-transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        -ms-transform: translate(0px, 0px) scaleX(0);
    }
}
.dots-width {
    width: 100%;
    margin: 0 auto;
}
.dot {
    border: 2px solid #bbb;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: inline-block;
    margin-left: 20px;
}
.footer-label {
    padding: 0;
    font-weight: 300;
    color: #cc0000;
    margin-top: 12px;
}
.เข้าใช้งานด้วยหมายเลขสมาชิกอื่น {
    text-align: left;
    width: 60%;
}
.ลืมรหัส {
    text-align: right;
    width: 40%;
}
.container-password {
    /* padding: 20px 16px; */
    text-align: center;
    border: unset;
    box-shadow: unset !important;
    /* width: 90%; */
    /* width: 100%; */

    /* background-color: #fff !important; */
    border-radius: 0;
    position: fixed;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
.container-password.is-desktop,
.container-password.is-tablet {
    /* width: auto; */
    width: 100%;
}
.container_forgot_password {
    padding: 8px;
    text-align: center;
    border: unset;
    box-shadow: unset !important;
    width: 100%;
    background-color: #fff !important;
    border-radius: 0;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
.container_forgot_password.is-desktop,
.container_forgot_password.is-tablet {
    width: 100%;
}
.container_forgot_member {
    padding: 8px;
    text-align: center;
    border: unset;
    box-shadow: unset !important;
    width: 100%;
    background-color: #fff !important;
    border-radius: 0;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
.container_forgot_member.is-desktop,
.container_forgot_member.is-tablet {
    width: 360px;
}
@media (max-device-width: 413px) and (max-device-height: 843px) {
    .pinC {
        width: 270px;
        height: 220px;
    }
    .pinC > .pinB {
        width: calc(270px / 3);
        height: calc(220px / 3);
    }
    .pinC > .pinB > .pin_T {
        font-size: 25px;
    }
    .container-password {
        /* width: 330px; */
        margin-top: 15%;
    }
    .container_forgot_member {
        width: 330px;
    }
}
@media (max-device-width: 374px) and (max-device-height: 843px) {
    .dots-width {
        width: 80%;
    }
    .dot {
        width: 15px;
        height: 15px;
        margin-left: 10px;
    }
    .pinC {
        width: 250px;
        height: 200px;
    }
    .pinC > .pinB {
        width: calc(250px / 3);
        height: calc(200px / 3);
    }
    .pinC > .pinB > .pin_T {
        font-size: 25px;
    }
    .container-password {
        /* width: 100% !important; */
        margin-top: 0;
    }
    .container_forgot_member {
        width: 100%;
    }
}
@media screen and (max-width: 1200px) {
    .col-xl-6 {
        width: 50%;
    }
}
@media (max-device-width: 15360px) and (max-device-height: 1080px) {
    .container-password {
        position: relative;
        left: unset;
        top: unset;
        -webkit-transform: unset;
        transform: unset;
        margin: 0 auto;
    }
}
</style>
